/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService
 */

export const getByIdRpc = {
  serviceName: 'com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService',
  rpcName: 'getById',
  auth: 'app',
  fingerprint: 'KnOD2gcBIe95VdN20b1FdeKjshJkSteP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPaginatedResponseRpc = {
  serviceName: 'com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService',
  rpcName: 'getPaginatedResponse',
  auth: 'app',
  fingerprint: 'pfBU4GDSJwjOvYgO0VacT-KjshJkSteP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getActiveByLanguageRpc = {
  serviceName: 'com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService',
  rpcName: 'getActiveByLanguage',
  auth: 'app',
  fingerprint: '8aVKVb3oUch8Jnk6UDyElOKjshJkSteP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createAnnouncementRpc = {
  serviceName: 'com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService',
  rpcName: 'createAnnouncement',
  auth: 'app',
  fingerprint: 'USyh7qpY5Xh5VdN20b1FdeKjshJkSteP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateAnnouncementRpc = {
  serviceName: 'com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService',
  rpcName: 'updateAnnouncement',
  auth: 'app',
  fingerprint: 'WXNRz-9mG4p5VdN20b1FdeKjshJkSteP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteAnnouncementRpc = {
  serviceName: 'com.hubspot.academy.studio.rpc.services.AcademyStudioAnnouncementChirpService',
  rpcName: 'deleteAnnouncement',
  auth: 'app',
  fingerprint: '6U3qriOr_M15VdN20b1FdeKjshJkSteP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};